export interface Pageable {
    page: number;
    size: number;
    sort?: string;
}

export const LIST_PAGE_SIZE = 10;
